import { DatePicker as AntdDatePicker } from 'antd';
import { type Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

// antd 5 pickers take Day.js values by default; the app still uses Moment, so every picker comes
// from this one Moment instance until the app moves to Day.js.
// @see https://ant.design/docs/react/use-custom-date-library
export const DatePicker = AntdDatePicker.generatePicker<Moment>(momentGenerateConfig);

export type DatePickerProps = React.ComponentProps<typeof DatePicker>;
export type RangePickerProps = React.ComponentProps<typeof DatePicker.RangePicker>;
